import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Project, Zone } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  useProjectModel(request: Boundaries["useProjectModel"]["request"]): void;
}

function useUseProjectModel(
  zone: Identifiable<Zone>,
  projectModel: Identifiable<Project>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isUseProjectModelRequestPending(projectModel, zone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isUseProjectModelRequestSuccess(projectModel, zone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isUseProjectModelRequestFailure(projectModel, zone),
    ),
    useProjectModel: core.useProjectModel,
  };
}

export { useUseProjectModel };
